import { useQuery } from 'react-query'

// Hooks
import { useAuthSettings } from '../authorization'

// Helpers
import { getQueryDefaults } from '../../helpers/api'

// Requests
import {
  getListingEvaluationByAddressAndPrice,
  getAppreciationIndicatorByAddressAndPrice,
  getMarketTempIndicatorByAddressAndPrice,
  getListingRentalPotentialByAddress,
} from './requests'

// TODO: rate and include rental toggle to be included here (rate arg not in mikasa yet)
export const useListingEvaluationQuery = (
  address,
  listingPrice,
  marketTempSliderPrice,
  appreciationSliderPercent,
  includeRental
) => {
  const authSettings = useAuthSettings()
  const price = marketTempSliderPrice || listingPrice

  return useQuery(
    [
      'listingEvaluation',
      address,
      price,
      appreciationSliderPercent,
      includeRental,
    ],
    () =>
      getListingEvaluationByAddressAndPrice(
        authSettings,
        address,
        price,
        appreciationSliderPercent,
        includeRental
      ),
    {
      ...getQueryDefaults(),
      enabled: Boolean(address && price && authSettings),
    }
  )
}

export const useValidateListingEvaluationQuery = (address, listingPrice) => {
  const authSettings = useAuthSettings()

  return useQuery(
    ['listingEvaluationValidation', address, listingPrice],
    () =>
      getListingEvaluationByAddressAndPrice(
        authSettings,
        address,
        listingPrice
      ),
    {
      ...getQueryDefaults(),
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      enabled: false, // turned off by default, manual refetch is needed
    }
  )
}

export const useAppreciationIndicatorQuery = (address, price) => {
  const authSettings = useAuthSettings()

  return useQuery(
    ['listingAppreciationIndicator', address, price],
    () =>
      getAppreciationIndicatorByAddressAndPrice(authSettings, address, price),
    {
      ...getQueryDefaults(),
      enabled: Boolean(address && price && authSettings),
    }
  )
}

export const useMarketTempIndicatorQuery = (address, price) => {
  const authSettings = useAuthSettings()

  return useQuery(
    ['listingMarketTempIndicator', address, price],
    () => getMarketTempIndicatorByAddressAndPrice(authSettings, address, price),
    {
      ...getQueryDefaults(),
      enabled: Boolean(address && price && authSettings),
    }
  )
}

export const useListingRentalPotentialQuery = address => {
  const authSettings = useAuthSettings()

  return useQuery(
    ['listingRentalPotential', address],
    () => getListingRentalPotentialByAddress(authSettings, address),
    {
      ...getQueryDefaults(),
      enabled: Boolean(address && authSettings),
    }
  )
}
